export const DEFAULT_PAGE_SIZE: Readonly<number> = 30
export const IS_DEV: Readonly<boolean> = process.env.NODE_ENV === 'development'
export const IS_PRODUCTION: Readonly<boolean> = process.env.NODE_ENV === 'production'
export const GATE_COOKIE: Readonly<string> = 'yumi_gate'
